import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=2a8275ff&"
import script from "./Tools.vue?vue&type=script&lang=ts&"
export * from "./Tools.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports